import React, { useEffect, useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import Card from '../../../components/Card'
import { Spinner } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { formatRupiah } from '../../../utilities/Utils'

const ExpandableComponentNonLalinPnbpV2 = ({ data, idPnbp }) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [listData, setListData] = useState([])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!data) return
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const _resDtlPeriksa = await nonLalinService.listNonlalinDtlPeriksaAll(data.trNonlalinDtlPK.nomorAju, data.trNonlalinDtlPK.seri)
                // console.log(_resDtlPeriksa)
                setListData(_resDtlPeriksa.data.data)
            } catch (error) {
                setListData([])
            }
            setLoading(false)
        }
        fetchAllData()
    }, [nonLalinService, data])

    const columns = [
        {
            name: 'Seri Tarif',
            cell: row => row['trNonlalinDtlPeriksaPK'].seriTarif,
            grow: 0.1
        },
        {
            name: 'Jenis Pengujian',
            cell: row => row['nmTarif']
        },
        {
            name: 'Tarif',
            cell: row => formatRupiah(row['tarif'])
        },
        {
            name: 'Satuan',
            cell: row => row['satuan']
        },
        {
            name: 'Volume',
            cell: row => row['volume'],
            grow: 0.2
        },
        {
            name: 'Total Tarif',
            cell: row => formatRupiah(row['totalTarif'])
        },
        {
            name: 'Kesiapan Cek UPT',
            cell: row => row['isUptCanCheck'] === 'Y' ? <><span className='text-success'>Diperiksa</span></> : <><span className='text-danger'>Tidak Diperiksa</span></>
        }
    ]

    // const [dataDtlPeriksa, setDataDtlPeriksa] = useState(null)
    // const [showPnbp, setShowPnbp] = useState(false)
    // const handleCloseShowPnbp = () => setShowPnbp(false)

    // const ProsesPnbp = (data) => {
    //     setDataDtlPeriksa(data)
    //     setShowPnbp(true)
    // }
    
    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <DataTable
                        customStyles={{ headCells: { style: { 'background-color': '#717475', 'color': 'white' } } }}
                        columns={columns}
                        data={listData}
                        persistTableHead={true}
                        highlightOnHover
                    />
                </Card.Body>
            </Card>
            {/* <ModalPnbpNonLalinDtl showPnbpDetil={showPnbp} handleCLoseModalPnbpDetil={handleCloseShowPnbp} dataPnbp={dataDtlPeriksa} idPnbp={idPnbp}/> */}
        </>
    )
}

export default ExpandableComponentNonLalinPnbpV2